import { MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useProductTypes } from "../../../services/productsService";
import { useLocalizedProperty } from "../../../utils";

const disabledInputSx = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#010a1a",
    },
};

export const ProductTypeDropdown = (props) => {
    const { control, fieldName, disabled = false } = props;
    const getLocalizedProperty = useLocalizedProperty();

    const { data } = useProductTypes();
    const types = data || [];

    if (types.length === 0) {
        return null;
    }

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
                <TextField
                    {...field}
                    select
                    fullWidth
                    disabled={disabled}
                    sx={disabled ? disabledInputSx : undefined}
                >
                    {types.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                            {getLocalizedProperty(type, "name")}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
